import type { PartialMessage } from '@bufbuild/protobuf'
import { useGetConfig } from '@jotta/grpc-connect-client/config'
import type { SupportChannel } from '@jotta/grpc-connect-openapi/esm/openapi/config/v2/config.v2_pb'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'
import { showNewIntercomMessage } from '@jotta/intercom'
import { Trans } from '@lingui/macro'
import { Fragment } from 'react'
import { LoadingOverlay } from '../../Layout/LoadingOverlay/LoadingOverlay'

function SupportChannelRow({
  channel,
}: {
  channel: PartialMessage<SupportChannel>
}) {
  if (!channel.type) {
    return null
  }

  switch (channel.type.case) {
    case 'email':
      return (
        <a className="link" href={`mailto:${channel.type.value.emailAddress}`}>
          {channel.type.value.emailAddress}
        </a>
      )
    case 'intercom':
      return (
        <button
          onClick={showNewIntercomMessage}
          className="btn btn-primary w-full"
        >
          Start a chat
        </button>
      )
    case 'phone':
      return (
        <p>
          <Trans>Call</Trans>&nbsp;{channel.type.value.phoneNumberFormatted}
        </p>
      )
    case 'web':
      return (
        <a
          href={channel.type.value.url}
          className="link"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>Open help center</Trans>
        </a>
      )
    case undefined:
      throw new Error('undefined')
    default:
      return exhaustiveGuard(channel.type)
  }
}

export function SupportChannels({
  customerGroupOverride,
}: {
  customerGroupOverride?: string
}) {
  const { data, isPending } = useGetConfig(customerGroupOverride)
  return (
    <div className="flex flex-col items-center gap-4">
      <LoadingOverlay open={isPending} />
      {data?.brandingInfo?.supportChannels?.map((channel, i) => (
        <Fragment key={channel.type?.case}>
          {i > 0 && (
            <p>
              <Trans>or</Trans>
            </p>
          )}
          <SupportChannelRow channel={channel} key={i} />
        </Fragment>
      ))}
    </div>
  )
}
